import { defineComponent } from "/Scripts/vue.esm-browser.js";
import HeaderLink from "./HeaderLink.js";
const html = String.raw;

export default defineComponent({
  name: "HeaderNavBottom",
  props: {
    webSite: {
      type: String,
      required: true,
    },
  },
  components: {
      HeaderLink
  },
  setup() {
    return {};
  },
  template: html`
    <div class="header-nav-bottom">
      <div class="header-menu">
        <ul class="menu-list">
          <li
            class="menu-list-item fadeInOut actionGlobal"
            id="world"
            alt="國外旅遊"
          >
            <a alt="國外旅遊">
              <span class="e-name">World</span>
              <span class="c-name">國外旅遊</span>
            </a>
          </li>
          <li class="menu-list-item" alt="世界遊輪">
            <a alt="世界遊輪" href="/Destination/5">
              <span class="e-name">Cruises</span>
              <span class="c-name">世界遊輪</span>
            </a>
          </li>
          <li
            v-if="webSite === 'b2c'"
            class="menu-list-item"
            id="backpacker"
            alt="機票+酒店"
          >
            <a
              href="https://fit.bwt.com.tw/"
              alt="日本/韓國/曼谷/香港機+酒"
              target="_blank"
              data-ad-key="hotel"
              rel="noopener noreferrer"
            >
              <span class="e-name">Backpacker</span>
              <span class="c-name flip flip1">機票+酒店</span>
              <span class="c-name flip flip2">有位有房</span>
              <span class="c-name flip flip3">立即確認</span>
            </a>
          </li>
          <li
            v-if="webSite === 'b2c'"
            class="menu-list-item"
            id="flights"
            alt="國際機票"
          >
            <a href="https://fit.bwt.com.tw/Ticket" alt="國際機票">
              <span class="e-name">Flights</span>
              <span class="c-name">國際機票</span>
            </a>
          </li>
          <li class="menu-list-item" id="khcdep" alt="高雄出發">
            <a href="/Destination/17" alt="高雄出發">
              <span class="e-name">KHC DEP</span>
              <span class="c-name">高雄出發</span>
            </a>
          </li>
          <li class="menu-list-item" id="txgdep" alt="台中出發">
            <a href="/Destination/16" alt="台中出發">
              <span class="e-name">TXG DEP</span>
              <span class="c-name">台中出發</span>
            </a>
          </li>
        </ul>
        <div class="menu-list-drop main-menu fadeInOut actionGlobal">
          <ul class="main-menu-list">
            <li
              class="dest-list-item"
              onclick="location.href='/Destination/01';"
            >
              <div class="dest-tag"><span>日本</span></div>
              <div class="menu-list-drop">
                <ul class="region-list">
                  <li>
                    <a href="/Destination/1/Group/sectGroupSAREA00002"
                      >北海道</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/1/Group/sectGroupSAREA00077">東北</a>
                  </li>
                  <li>
                    <a href="/Destination/1/Group/sectGroupSAREA00003">東京</a>
                  </li>
                  <li>
                    <a href="/Destination/1/Group/sectGroupSAREA00078"
                      >北陸．立山</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/1/Group/sectGroupSAREA00410">四國</a>
                  </li>
                  <li>
                    <a href="/Destination/1/Group/sectGroupSAREA00004">大阪</a>
                  </li>
                  <li>
                    <a href="/Destination/1/Group/sectGroupSAREA00005">九州</a>
                  </li>
                  <li>
                    <a href="/Destination/1/Group/sectGroupSAREA00411"
                      >沖繩．石垣島</a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="dest-list-item"
              onclick="location.href='/Destination/02';"
            >
              <div class="dest-tag"><span>韓國</span></div>
              <div class="menu-list-drop">
                <ul class="region-list">
                  <li>
                    <a href="/Destination/2/Group/sectGroupSAREA00006">首爾</a>
                  </li>
                  <li>
                    <a href="/Destination/2/Group/sectGroupSAREA00691"
                      >江原道</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/2/Group/sectGroupSAREA00007"
                      >濟州島</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/2/Group/sectGroupSAREA00008"
                      >釜山．大邱．慶州</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/2/Group/sectGroupSAREA00595"
                      >全羅道（務安）</a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="dest-list-item"
              onclick="location.href='/Destination/05';"
            >
              <div class="dest-tag"><span>遊輪</span><span>河輪</span></div>
              <div class="menu-list-drop">
                <ul class="region-list">
                  <li>
                    <a href="/Destination/5/Cruises/sectCruisesSAREA00716"
                      >基隆出發日韓遊輪</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/5/Cruises/sectCruisesSAREA00627"
                      >日本．韓國</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/5/Cruises/sectCruisesSAREA00051"
                      >阿拉斯加冰河灣</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/5/Cruises/sectCruisesSAREA00623"
                      >地中海．愛琴海</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/5/Cruises/sectCruisesSAREA00624"
                      >北歐．峽灣．冰島．英國列島</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/5/Cruises/sectCruisesSAREA00056"
                      >中東．古文明．非洲</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/5/Cruises/sectCruisesSAREA00465"
                      >加勒比海．墨西哥</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/5/Cruises/sectCruisesSAREA00625"
                      >紐西蘭．澳洲．大洋洲</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/5/Cruises/sectCruisesSAREA00709"
                      >歐洲頂級維京河輪</a
                    >
                  </li>
                </ul>
              </div>
            </li>

            <li
              class="dest-list-item"
              onclick="location.href='/Destination/09';"
              style="display:none;"
            >
              <div class="dest-tag"><span>海島</span></div>
              <div class="menu-list-drop">
                <ul class="region-list">
                  <li>
                    <a href="/Destination/9/Group/sectGroupSAREA00157">關島</a>
                  </li>
                  <li>
                    <a href="/Destination/9/Group/sectGroupSAREA00158">帛琉</a>
                  </li>
                  <li>
                    <a href="/Destination/11/Group/sectGroupSAREA00092"
                      >長灘島</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/11/Group/sectGroupSAREA00126">宿霧</a>
                  </li>
                  <li>
                    <a href="/Destination/9/Group/sectGroupSAREA00323"
                      >馬爾地夫</a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="dest-list-item"
              onclick="location.href='/Destination/13';"
            >
              <div class="dest-tag"><span>歐洲</span></div>
              <div class="menu-list-drop">
                <ul class="region-m-list">
                  <li class="region-m-list-item">
                    <a href="/Destination/13/Group/sectGroupSAREA00337"
                      >中西歐</a
                    >
                    <ul class="city-list">
                      <li class="city-list-item">
                        <a href="/Destination/13/Group/sectGroupSAREA00337"
                          >德國．德瑞</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/13/Group/sectGroupSAREA00611"
                          >瑞士．法瑞義</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/13/Group/sectGroupSAREA00569"
                          >英．荷．比．法</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="region-m-list-item">
                    <a href="/Destination/13/Group/sectGroupSAREA00574">北歐</a>
                    <ul class="city-list">
                      <li class="city-list-item">
                        <a href="/Destination/13/Group/sectGroupSAREA00574"
                          >北歐四國．冰島</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="region-m-list-item">
                    <a href="/Destination/13/Group/sectGroupSAREA00571">東歐</a>
                    <ul class="city-list">
                      <li class="city-list-item">
                        <a href="/Destination/13/Group/sectGroupSAREA00571"
                          >奧捷．匈牙利</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/13/Group/sectGroupSAREA00572"
                          >克斯．大東歐</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="region-m-list-item">
                    <a href="/Destination/13/Group/sectGroupSAREA00567">南歐</a>
                    <ul class="city-list">
                      <li class="city-list-item">
                        <a href="/Destination/13/Group/sectGroupSAREA00567"
                          >義大利</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/13/Group/sectGroupSAREA00609"
                          >西班牙．葡萄牙．摩洛哥</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/13/Group/sectGroupSAREA00100"
                          >希臘</a
                        >
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="dest-list-item"
              onclick="location.href='/Destination/12';"
            >
              <div class="dest-tag"><span>美加</span><span>紐澳</span></div>
              <div class="menu-list-drop">
                <ul class="region-list">
                  <li>
                    <a href="/Destination/12/Group/sectGroupSAREA00041"
                      >美加西岸</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/12/Group/sectGroupSAREA00040"
                      >加拿大</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/12/Group/sectGroupSAREA00467"
                      >紐西蘭</a
                    >
                  </li>
                  <li><a href="/Destination/12">澳洲</a></li>
                  <li><a href="/Destination/12/Group/sectGroupSAREA00720">紐西蘭．澳洲．斐濟</a></li>
                </ul>
              </div>
            </li>
            <li
              class="dest-list-item"
              onclick="location.href='/Destination/12/Group/sectGroupSAREA00540';"
              style="display:none;"
            >
              <div class="dest-tag"><span>紐澳</span></div>
              <div class="menu-list-drop">
                <ul class="region-list">
                  <li>
                    <a href="/Destination/12/Group/sectGroupSAREA00540">澳洲</a>
                  </li>
                  <li>
                    <a href="/Destination/12/Group/sectGroupSAREA00541"
                      >澳洲單點</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/12/Group/sectGroupSAREA00467"
                      >紐西蘭</a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="dest-list-item"
              onclick="location.href='/Destination/14';"
            >
              <div class="dest-tag">
                <span style="line-height: 1.2em; padding-top: 0.1em;">中東</span>
                <span style="line-height: 1.2em;">南亞</span>
                <span style="line-height: 1.2em;">非洲</span>
            </div>
              <div class="menu-list-drop">
                <ul class="region-list">
                  <li>
                    <a href="/Destination/14/Group/sectGroupSAREA00107">印度</a>
                  </li>
                  <li>
                    <a href="/Destination/14/Group/sectGroupSAREA00607"
                      >尼泊爾．斯里蘭卡</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/14/Group/sectGroupSAREA00096"
                      >土耳其</a
                    >
                  </li>
                  <li>
                    <a href="/Destination/14/Group/sectGroupSAREA00108">杜拜</a>
                  </li>
                  <li>
                    <a href="/Destination/14/Group/sectGroupSAREA00099">埃及</a>
                  </li>
                  <li>
                    <a href="/Destination/14/Group/sectGroupSAREA00100">希臘</a>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="dest-list-item"
            >
              <div class="dest-tag" style="cursor: default;"><span>東南亞</span></div>
              <div class="menu-list-drop">
                <ul class="region-m-list">
                  <li class="region-m-list-item">
                    <a href="/Destination/08">泰國</a>
                    <ul class="city-list">
                      <li class="city-list-item">
                        <a href="/Destination/8/Group/sectGroupSAREA00011"
                          >曼谷</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/8/Group/sectGroupSAREA00115"
                          >泰北</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/8/Group/sectGroupSAREA00009"
                          >普吉島</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/8/Group/sectGroupSAREA00010"
                          >蘇梅島</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="region-m-list-item">
                    <a href="/Destination/10">印尼</a>
                    <ul class="city-list">
                      <li class="city-list-item">
                        <a href="/Destination/10/Group/sectGroupSAREA00058"
                          >峇里島</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="region-m-list-item">
                    <a href="/Destination/11">菲律賓</a>
                    <ul class="city-list">
                      <li class="city-list-item">
                        <a href="/Destination/11/Group/sectGroupSAREA00092"
                          >長灘島</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/11/Group/sectGroupSAREA00126"
                          >宿霧</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/11/Group/sectGroupSAREA00235"
                          >巴拉望</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/11/Group/sectGroupSAREA00125"
                          >馬尼拉</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="region-m-list-item">
                    <a href="/Destination/15">中南半島</a>
                    <ul class="city-list">
                      <li class="city-list-item">
                        <a href="/Destination/15/Group/sectGroupSAREA00629"
                          >北越</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/15/Group/sectGroupSAREA00630"
                          >中越</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/15/Group/sectGroupSAREA00631"
                          >南越</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="region-m-list-item">
                    <a href="/Destination/07">馬新汶</a>
                    <ul class="city-list">
                      <li class="city-list-item">
                        <a href="/Destination/7/Group/sectGroupSAREA00061"
                          >吉隆坡</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/7/Group/sectGroupSAREA00062"
                          >檳城</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/7/Group/sectGroupSAREA00193"
                          >新加坡</a
                        >
                      </li>
                      <li class="city-list-item">
                        <a href="/Destination/7/Group/sectGroupSAREA00690"
                          >汶萊</a
                        >
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>
            <li class="dest-list-item" onclick="location.href='/Destination/04';">
                                    <div class="dest-tag"><span>中國</span></div>
                                    <div class="menu-list-drop">
                                        <ul class="region-m-list">
                                            <li class="region-m-list-item">
                                                <a href="/Destination/04/SAREA00026">華北</a>
                                                <ul class="city-list">
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00026">北京．天津．河北</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00030">山西五台山</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00436">內蒙古</a></li>
                                                </ul>
                                            </li>
                                            <li class="region-m-list-item">
                                                <a href="/Destination/04/SAREA00105">華東</a>
                                                <ul class="city-list">
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00105">江南．上海</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00024">黃山千島湖</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00090">江西三大名山</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00089">山東</a></li>
                                                </ul>
                                            </li>
                                            <li class="region-m-list-item">
                                                <a href="/Destination/04/SAREA00088">華南</a>
                                                <ul class="city-list">
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00088">廣西．桂林南寧</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00087">廣東</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00085">福建</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00086">金門．廈門</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00084">海南島</a></li>
                                                </ul>
                                            </li>
                                            <li class="region-m-list-item">
                                                <a href="/Destination/04/SAREA00027">華中</a>
                                                <ul class="city-list">
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00028">湖南張家界</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00027">河南鄭州</a></li>

                                                </ul>
                                            </li>
                                            <li class="region-m-list-item">
                                                <a href="/Destination/04/SAREA00082">西南</a>
                                                <ul class="city-list">
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00082">雲南昆大麗</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00083">貴州黃果樹</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00029">長江三峽</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00081">四川．九寨溝．稻城亞丁</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00325">西藏．青海</a></li>
                                                </ul>
                                            </li>
                                            <li class="region-m-list-item">
                                                <a href="/Destination/04/SAREA00032">西北/東北</a>
                                                <ul class="city-list">
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00032">絲路．甘肅</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00031">新疆</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00537">寧夏銀川</a></li>
                                                    <li class="city-list-item"><a href="/Destination/04/SAREA00025">東北三省</a></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
            <li
              class="dest-list-item"
              onclick="location.href='/Destination/03';"
            >
              <div class="dest-tag"><span>港澳</span></div>
              <div class="menu-list-drop">
                <ul class="region-list">
                  <li>
                    <a href="/Destination/3/Group/sectGroupSAREA00172"
                      >自由行</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <header-link :web-site="webSite"></header-link>
    </div>
  `,
});
